module.exports = __webpack_public_path__ + "static/media/briefcase.5599bc30.svg";